import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  border-radius: 6px;\n  padding: 0 16px 0 8px;\n  background-color: ",
        ";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n  &:hover,\n  &.active {\n    border: 1px solid ",
        ";\n  }\n  &.active {\n    background-color: ",
        ";\n  }\n  input,\n  textarea {\n    padding: 8px 0 8px 8px;\n    line-height: 1.5;\n    width: 100%;\n    min-height: auto;\n    background-color: transparent;\n    border: unset;\n    font-size: 16px;\n    &:focus {\n      outline: none !important;\n    }\n\n    &::placeholder {\n      color: ",
        ";\n    }\n  }\n\n  button {\n    all: unset;\n    height: 20px;\n    display: flex;\n    align-items: center;\n  }\n  .delete-btn {\n    margin-left: 8px;\n    i {\n      background-color: ",
        ";\n      border-radius: 50%;\n      padding: 2px;\n    }\n    div {\n      margin: 0 12px;\n    }\n  }\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    max-width: unset;\n    input {\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Close, Search, Sizes } from "@/components/icon/IconList";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Input } from "antd";
import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
const InputWrapper = styled.div.withConfig({
    componentId: "sc-da2280ea-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_800);
const TextFieldContext = /*#__PURE__*/ createContext({});
const InputContainer = (param)=>{
    let { children , value , onBlur , onClear , search , onSearchClick , searchButtonType  } = param;
    const theme = useTheme();
    const { width  } = useWindowDimensions();
    const isMobile = useMemo(()=>width < 769, [
        width
    ]);
    const inputRef = useRef({
        element: null,
        focusTimeout: null
    });
    const [focused, setFocused] = useState(false);
    const handleFocus = useCallback(()=>{
        clearTimeout(inputRef.current.focusTimeout);
        setFocused(true);
    }, []);
    const handleBlur = useCallback(()=>{
        inputRef.current.focusTimeout = setTimeout(()=>{
            setFocused(false);
        }, 100);
        if (onBlur) {
            onBlur();
        }
    }, [
        onBlur
    ]);
    const handleClear = useCallback(()=>{
        if (onClear) {
            onClear();
        }
        if (inputRef.current.element) {
            inputRef.current.element.focus();
        }
    }, [
        onClear
    ]);
    return /*#__PURE__*/ _jsx(TextFieldContext.Provider, {
        value: {
            inputRef,
            focused,
            setFocused,
            handleFocus,
            handleBlur
        },
        children: /*#__PURE__*/ _jsxs(InputWrapper, {
            className: "textfield ".concat((focused || (value === null || value === void 0 ? void 0 : value.length)) && "active"),
            children: [
                children,
                !!onClear && (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/ _jsxs("button", {
                    className: "delete-btn",
                    onClick: handleClear,
                    type: "button",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Close,
                            size: isMobile ? Sizes.xxsmall : Sizes.xsmall,
                            color: "#fff"
                        }),
                        (onSearchClick || search) && /*#__PURE__*/ _jsx("div", {
                            children: "ㅣ"
                        })
                    ]
                }),
                (onSearchClick || search) && /*#__PURE__*/ _jsx("button", {
                    onClick: onSearchClick,
                    type: searchButtonType || "submit",
                    children: /*#__PURE__*/ _jsx(Icon, {
                        icon: Search,
                        size: isMobile ? Sizes.small : Sizes.xmedium,
                        color: theme.new.colors.sol_gray_800
                    })
                })
            ]
        })
    });
};
const TextField = (param)=>{
    let { onClick , onChange , fieldRef , search , ...props } = param;
    const { inputRef , handleFocus , handleBlur  } = useContext(TextFieldContext);
    const handleClick = useCallback((ev)=>{
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    }, [
        onClick
    ]);
    const setupRef = useCallback((el)=>{
        if (inputRef) {
            inputRef.current.element = el;
        }
        fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef(el);
    }, [
        fieldRef
    ]);
    const formProps = {
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onChange
    };
    return /*#__PURE__*/ _jsx(InputContainer, {
        ...props,
        children: /*#__PURE__*/ _jsx("input", {
            ref: setupRef,
            ...formProps,
            ...search && {
                type: "search"
            },
            ...props
        })
    });
};
export default TextField;
export const TextAreaField = (param)=>{
    let { onClick , onChange , fieldRef , search , ...props } = param;
    const { inputRef , handleFocus , handleBlur  } = useContext(TextFieldContext);
    const handleClick = useCallback((ev)=>{
        onClick === null || onClick === void 0 ? void 0 : onClick(ev);
    }, [
        onClick
    ]);
    const setupRef = useCallback((el)=>{
        if (inputRef) {
            inputRef.current.element = el;
        }
        fieldRef === null || fieldRef === void 0 ? void 0 : fieldRef(el);
    }, [
        fieldRef
    ]);
    const formProps = {
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onChange
    };
    return /*#__PURE__*/ _jsx(InputContainer, {
        ...props,
        children: /*#__PURE__*/ _jsx(Input.TextArea, {
            ref: setupRef,
            ...formProps,
            ...search && {
                type: "search"
            },
            ...props
        })
    });
};
